module.exports = __webpack_public_path__ + "img/lukoil-logo-white-en.949d7f0e.svg";